import React, { useMemo, useState } from "react";

import { Button } from "reactstrap";
import PropTypes from "prop-types";
import { CfSelect as Select } from "../../components/CfSelect";
import { useHistory } from "react-router-dom";

const SORT_OPTIONS = [
  { value: "desc", label: "Newest first" },
  { value: "asc", label: "Oldest first" },
];

// Missions of a site, with date filter + sort. Open results on the map,
// download results when the user may (onDownload, called with the date).
export const MissionsPanel = ({ site, missions, onDownload }) => {
  const history = useHistory();
  const [query, setQuery] = useState("");
  const [sort, setSort] = useState("desc");

  const total = missions?.length ?? 0;

  const visible = useMemo(() => {
    const needle = query.trim().toLowerCase();
    const filtered = (missions ?? []).filter(
      (mission) =>
        !needle || String(mission.date).toLowerCase().includes(needle)
    );
    return [...filtered].sort((a, b) =>
      sort === "desc"
        ? String(b.date).localeCompare(String(a.date))
        : String(a.date).localeCompare(String(b.date))
    );
  }, [missions, query, sort]);

  return (
    <div className="cf-section">
      <div className="cf-section__head">
        <h4 className="cf-section__title mb-0">Missions</h4>
        {total > 0 && (
          <div className="cf-section__tools">
            <div className="cf-search">
              <i className="fa-solid fa-magnifying-glass" aria-hidden="true" />
              <input
                type="text"
                value={query}
                placeholder="Filter by date…"
                onChange={(event) => setQuery(event.target.value)}
                aria-label="Filter missions by date"
              />
              {query && (
                <button
                  type="button"
                  className="cf-search__clear"
                  onClick={() => setQuery("")}
                  aria-label="Clear"
                >
                  <i className="fa-solid fa-xmark" />
                </button>
              )}
            </div>
            <Select
              className="cf-rs"
              classNamePrefix="cf-rs"
              isSearchable={false}
              options={SORT_OPTIONS}
              value={SORT_OPTIONS.find((option) => option.value === sort)}
              onChange={(option) => setSort(option.value)}
              aria-label="Sort missions"
            />
          </div>
        )}
      </div>

      {total === 0 ? (
        <div className="cf-placeholder">No mission recorded for this site.</div>
      ) : visible.length === 0 ? (
        <div className="cf-placeholder">No mission matches your filter.</div>
      ) : (
        visible.map((mission) => (
          <div className="cf-mission-row" key={mission.id ?? mission.date}>
            <span className="cf-mission-row__date">{mission.date}</span>
            <span className="cf-mission-row__actions">
              <Button
                data-tooltip-id="tooltip"
                data-tooltip-content="View result on map"
                className="p-0"
                color="link"
                onClick={() => history.push(`/map/${site.id}/${mission.date}`)}
              >
                <i className="fa-solid fa-lg fa-earth-americas" />
              </Button>
              {onDownload && (
                <Button
                  data-tooltip-id="tooltip"
                  data-tooltip-content="Download results"
                  className="p-0 ms-2"
                  color="link"
                  onClick={() => onDownload(String(mission.date))}
                >
                  <i className="download_icon" />
                </Button>
              )}
            </span>
          </div>
        ))
      )}
    </div>
  );
};

MissionsPanel.propTypes = {
  site: PropTypes.object.isRequired,
  missions: PropTypes.array,
  onDownload: PropTypes.func,
};
